<script>
  import { client } from 'root/api/index.js';
  import { onMount, getContext, setContext, onDestroy } from 'svelte';
  import DropDown from '../DropDown.svelte';
  import { createEventDispatcher } from 'svelte';
  import { getHashUrlParam, searchKeyByValue } from 'components/Helper.js';
  const dispatch = createEventDispatcher();
  import { masterData, getMasterData } from '../../stores/masterData.js';
  import {
    dashboardData,
    getDashboardData,
    setDashboardData,
    resetDashboardData,
  } from '../../stores/dashboard.js';
  import { ISO_8601 } from 'moment';
  import AssignTaskSubFilter from './AssignTaskSubFilter.svelte';
  let businesType = [
    { id: 1, text: 'US Compliances' },
    { id: 2, text: 'UK Compliances' },
    { id: 2, text: 'Outsourced' },
    { id: 2, text: 'CFO' },
    { id: 2, text: 'Fund Admin' },
  ];

  // let client = [
  // 	{ id: 1, text: 'Almitas' },
  // 	{ id: 2, text: 'City View' },
  // 	{ id: 3, text: 'Crowd Street' },
  // ];

  let assignmentMethod = [
    { id: 1, text: 'Ongoing' },
    { id: 2, text: 'Project' },
  ];
  function toggleFilter() {
    dispatch('toggleFilter', { ...extraFilter });
  }
  let projects = [];
  let units = [];
  let clients = [];
  let clientFundProfiles = [];
  const getUnitUsers = () => {
    let filter = { units: [{ unitId: extraFilter.unitId }] };
    if (extraFilter.clientId > 0 && extraFilter.taskType == 1) {
      filter.clients = [{ id: extraFilter.clientId }];
    }
    client.unitUsers(filter).then((response) => {
      extraFilter.unitUsers = response.data.users.map((item) => {
        item.fullName = item.firstName + ' ' + item.lastName;
        return item;
      });
    });
  };
  const getUnitDetail = () => {
    if (extraFilter.unitId > 0) {
      client.unitClients({ units: [{ unitId: extraFilter.unitId }] }).then((response) => {
        clients = response.data.clients;
        clientFundProfiles = response.data.clientFundProfiles;
        if (extraFilter.clientId > 0) {
          for (var i in clients) {
            if (clients[i].id == extraFilter.clientId) {
              clientName = clients[i].name;
              extraFilter.clientName = clientName;
              extraFilter.clientFundProfile = clientFundProfiles.filter((item) => {
                return item.clientId == extraFilter.clientId;
              });
              break;
            }
          }
        }
      });

      getUnitUsers();

      client
        .getUnitProject({
          units: [{ unitId: extraFilter.unitId, id: extraFilter.unitId }],
        })
        .then((response) => {
          extraFilter.unitProjectId = '';
          projects = response.data.projects;
        });
    }
  };
  let taskType = [
    { id: 1, text: 'Client' },
    { id: 2, text: 'Internal' },
  ];
  let defaultFilter = {
    taskType: '',
    unitProjectId: '',
    unitId: 0,
    clientId: 0,
    clientFundProfile: [],
    unitUsers: [],
    taskSubType: '',
    clientTypes: [],
    registrationTypes: [],
    projectTypes: [],
    taskActivityTypes: [],
  };
  let extraFilter = { ...defaultFilter };
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = getMasterData().units;
      }
    });
  });

  const dashboardUnsubscribe = dashboardData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined && units) {
        units = units.map((item) => {
          item.checked = searchKeyByValue(state.units, 'id', item.id) != -1;
          return item;
        });
        if (units.filter((item) => item.checked).length == 1) {
          let selectedUnit = units.filter((item) => item.checked)[0];
          extraFilter = {
            ...extraFilter,
            unitId: selectedUnit.id,
            resposiblePartyName: getResposiblePartyLabel(selectedUnit.id),
          };
          getUnitDetail();
        }
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
    dashboardUnsubscribe();
  });

  onMount(() => {
    checkUrl();
  });

  const checkUrl = () => {
    setTimeout(() => {
      let params = getHashUrlParam();
      if (params.action != undefined) {
        extraFilter.unitId = params.unitId;
        extraFilter.taskType = 1;
        extraFilter.clientId = params.clientId;
        extraFilter.taskSubType = params.type == 'project' ? 2 : 1;
        getUnitDetail();
        setTimeout(() => {
          toggleFilter();
          window.location.hash = '';
        }, 1500);
      }
    }, 500);
  };

  const getUnitName = (unitId) => {
    if (unitId > 0) {
      return units[searchKeyByValue(units, 'id', unitId)].name;
    } else {
      return 'Business Unit';
    }
  };

  const getTypeName = (typeId) => {
    if (typeId > 0) {
      return assignmentMethod[searchKeyByValue(assignmentMethod, 'id', typeId)].text;
    } else {
      return 'Engagement type';
    }
  };
  const getResposiblePartyLabel = (unitId) => {
    if (unitId > 0) {
      return units[searchKeyByValue(units, 'id', unitId)].responsible_party_name;
    } else {
      return 'Us';
    }
  };
  let clientName;
</script>

<div class="card-content bg-white top-menu-filter border-0 d-flex flex-row justify-content-between">
  <div class="d-flex flex-row align-items-center">
    <div class="dropdown btn-drop-down">
      <DropDown
        titleChanged={true}
        checkbox={false}
        active={false}
        title={getUnitName(extraFilter.unitId)}
        option={units}
        checkedFields="checked"
        Style="select-block font-size-13 w-100"
        on:onSelect={(ev) => {
          extraFilter = {
            ...defaultFilter,
            unitId: ev.detail.id,
            unitName: getUnitName(ev.detail.id),
            resposiblePartyName: getResposiblePartyLabel(ev.detail.id),
          };
          getUnitDetail();
          setDashboardData({
            ...getDashboardData(),
            units: ev.detail ? [ev.detail] : [],
            taskServiceType: [],
            taskActivityTypes: [],
          });
        }}
      />
    </div>

    {#if extraFilter.unitId > 0}
      <DropDown
        defaultTitle="Task Type"
        title={extraFilter.taskType == '' ? 'Task Type' : taskType[extraFilter.taskType - 1].text}
        option={taskType}
        Style="select-block"
        titleChanged={true}
        on:onSelect={(event) => {
          extraFilter.taskType = event.detail.id != undefined ? event.detail.id : '';
          extraFilter.unitProjectId = 0;
          extraFilter.clientId = 0;
        }}
      />

      {#if extraFilter.taskType == 2}
        <DropDown
          title="Projects"
          searchbox={true}
          option={projects}
          Style="select-block "
          titleChanged={true}
          on:onSelect={(event) => {
            extraFilter.unitProjectId = event.detail.id;
          }}
        />
      {:else if extraFilter.taskType == 1}
        <div class="dropdown btn-drop-down">
          <DropDown
            searchbox={true}
            titleChanged={true}
            checkbox={false}
            active={true}
            title={clientName ? clientName : 'Client'}
            option={clients}
            Style="select-block font-size-13 w-100 assign-task-dropdown"
            on:onSelect={(ev) => {
              extraFilter.clientName = ev.detail.name;
              extraFilter.taskSubType = '';
              extraFilter.clientId = ev.detail.id != undefined ? ev.detail.id : 0;
              extraFilter.clientFundProfile = clientFundProfiles.filter((item) => {
                return item.clientId == extraFilter.clientId;
              });
              getUnitUsers();
            }}
          />
        </div>

        {#if extraFilter.clientId > 0}
          <div class="dropdown btn-drop-down">
            <DropDown
              checkbox={false}
              active={true}
              title={getTypeName(extraFilter.taskSubType)}
              option={assignmentMethod}
              Style="select-block font-size-13 w-100"
              titleChanged={true}
              on:onSelect={(ev) => {
                extraFilter.taskSubType = ev.detail.id;
                // toggleFilter()
              }}
            />
          </div>
        {/if}
      {/if}
    {/if}
  </div>
  {#if extraFilter.unitId > 0 && (extraFilter.unitProjectId > 0 || (extraFilter.clientId > 0 && extraFilter.taskSubType > 0))}
    <button
      on:click={toggleFilter}
      class="btn btn-primary font-size-13 shadow-none px-3">Apply</button
    >
  {/if}
</div>
